module.exports = __webpack_public_path__ + "img/overlay.56b9b29b.png";